export default __webpack_public_path__ + "static/media/StripsWhite.824a6334.svg";